import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MessagingComponent } from './messaging.component';
import { MessageComponent } from './message/message.component';
import { ComposeComponent } from './compose/compose.component';
import { MailboxComponent } from './mailbox/mailbox.component';

const messagingRoutes: Routes = [
	{
		path: '',
		component: MessagingComponent,
		data: {
			title: 'Messaging',
		},
		children: [
			{
				path: 'mailbox/:section',
				component: MailboxComponent,
				data: {
					title: 'Messaging',
				},
			},
			{
				path: 'mailbox/:section/message/:message_params',
				component: MessageComponent,
				data: {
					title: 'Messaging',
				},
			},
			{
				path: 'compose',
				component: ComposeComponent,
				data: {
					title: 'Messaging - Compose',
				},
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(messagingRoutes)],
	exports: [RouterModule],
})
export class MessagingRoutingModule {}
